import { createUploadLink } from "apollo-upload-client";

export const httpLink = createUploadLink({
  // You should use an absolute URL here
  uri: process.env.VUE_APP_NOVA_API_URL,
});
